jQuery(function($) {
  if ($('#item-detail-info').length) {
    const itemDetailAccordion = $('.js-item-detail-accordion');
    itemDetailAccordion.on('click', function () {
      $(this).addClass('__on');
    });
  }
});


(function($){
  $('.js-accordion-sw').on('click',function(){
    $(this).closest('.js-accordion').toggleClass('open').find('.js-accordion-content').slideToggle(100);
  });
})(jQuery);


$(function () {
    var headerHeight = 100; // ヘッダーの高さ
    $('a[href^="#"]').click(function(){
        var href = $(this).attr("href");
        var target = $(href === "#" || href === "" ? 'html' : href);
        var position = target.offset().top - headerHeight; // ヘッダーの高さ分位置をずらす
        $("html, body").animate({scrollTop: position}, 550, "swing");
        return false;
    });
});


/* 開閉イージング */
document.querySelectorAll("details.details").forEach((details) => {
  const summary = details.querySelector("summary");
  const content = details.querySelector("summary + *");

  const onClick = (event) => {
    if (details.open) {
      event.preventDefault();
      details.setAttribute("data-accordion-before-close", "");
      gsap.to(content, {
        height: 0,
        ease: "linear", 
        duration: 0.25,
        onComplete: () => {
          details.open = false;
          details.removeAttribute("data-accordion-before-close");
        },
      });
    } else {
      gsap.fromTo(content, { height: 0 }, {
        height: "auto",
        ease: "linear", 
         duration: 0.25,
      });
    }
  };

  summary.addEventListener("click", onClick, { passive: false });
});


// TOPスライドボタンとドロワーの被り調整
// $(function () {
//   $('.header__icon').on('click', function(){
//     $('.swiper-button-next, .swiper-button-prev').toggleClass('is-hide');
//   });
// });

// 商品ページ ページ上部へ戻る
 $(function () {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 1000) { // ボタンが表示されるスクロール位置を調整（この場合は100）
        $('.smoothscroll-top').fadeIn();
      } else {
        $('.smoothscroll-top').fadeOut();
      }
    });

    $('.smoothscroll-top').click(function () {
      var speed = 300;
      $("html, body").animate({ scrollTop: 0 }, speed, "swing");
      return false;
    });
  });
